var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-responsability-box"},[_c('b-checkbox',{staticClass:"check",on:{"input":_vm.updateValue},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.hasError)?_c('p',{staticClass:"check-error"},[_vm._v(" "+_vm._s(_vm.errorLabel)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }